module.exports = __webpack_public_path__ + "media/images/icons/filter-aac4f44ef421787974821057f499ae87.svg";